const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/style/$slug.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/style/$slug")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});